"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeLanguageSelect = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
/**
 * @internal
 */
exports.CodeLanguageSelect = function (props) {
    var selectedLanguage = props.selectedLanguage, onLanguageChanged = props.onLanguageChanged;
    var onCheck = react_1.useCallback(function (e) {
        var value = e.target.value;
        onLanguageChanged(value);
    }, [onLanguageChanged]);
    return (react_1.default.createElement("div", { className: "embed-insight-dialog-lang-selector" },
        react_1.default.createElement("strong", { className: "bottom-space" },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "embedInsightDialog.code.language.codeAs" })),
        react_1.default.createElement("label", { className: "input-radio-label bottom-space s-language-ts" },
            react_1.default.createElement("input", { type: "radio", className: "input-radio", value: "ts", checked: selectedLanguage === "ts", onChange: onCheck }),
            react_1.default.createElement("span", { className: "input-label-text" }, "TypeScript")),
        react_1.default.createElement("label", { className: "input-radio-label bottom-space s-language-js" },
            react_1.default.createElement("input", { type: "radio", className: "input-radio", value: "js", checked: selectedLanguage === "js", onChange: onCheck }),
            react_1.default.createElement("span", { className: "input-label-text" }, "JavaScript"))));
};
//# sourceMappingURL=CodeLanguageSelect.js.map